import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRewardsNav = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M11.5 8a1.5 1.5 0 0 0 0 3h3.154a8.206 8.206 0 0 0-.468-1.018C13.557 8.838 12.694 8 11.5 8ZM8 9.5a3.5 3.5 0 0 0 .338 1.5H6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-9h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1h-2.338A3.5 3.5 0 0 0 20.5 6c-2.306 0-3.693 1.662-4.439 3.018a9.66 9.66 0 0 0-.061.113 9.66 9.66 0 0 0-.061-.113C15.193 7.662 13.806 6 11.5 6A3.5 3.5 0 0 0 8 9.5Zm9.346 1.5H20.5a1.5 1.5 0 1 0 0-3c-1.194 0-2.057.838-2.686 1.982A8.206 8.206 0 0 0 17.346 11ZM17 13v3h8v-3h-8Zm-5.5 0H15v3H7v-3h4.5ZM17 26h6v-8h-6v8Zm-2-8v8H9v-8h6Z",
		clipRule: "evenodd"
	})
});
export default SvgRewardsNav;
